export const LOAN_PLANS = [
  { key: "plan1", label: "Plan 1" },
  { key: "plan2", label: "Plan 2" },
  { key: "postgraduate", label: "Postgraduate" },
  { key: "plan4", label: "Plan 4" },
  { key: "plan5", label: "Plan 5" },
];

export const LOAN_PLAN_LABELS = LOAN_PLANS.reduce((acc, plan) => {
  acc[plan.key] = plan.label;
  return acc;
}, {});
